export default {
    'name': 'facebook',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<g clip-path=\'url(#clip0_1887_38206)\'><path d=\'M12.6583 12.752H15.895L16.4032 9.44396H12.6577V7.63595C12.6577 6.26173 13.104 5.04315 14.3817 5.04315H16.4348V2.1563C16.0741 2.10729 15.3111 2 13.8695 2C10.8593 2 9.09449 3.59939 9.09449 7.24322V9.44396H6V12.752H9.09449V21.8444C9.70734 21.9371 10.3281 22 10.9653 22C11.5413 22 12.1034 21.947 12.6583 21.8715V12.752Z\' fill=\'#026958\'/></g><defs><clipPath id=\'clip0_1887_38206\'><rect width=\'11\' height=\'20\' fill=\'white\' transform=\'translate(6 2)\'/></clipPath></defs>'
}
